import { useMemo, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

const getAppliedFilters = (searchParams: URLSearchParams) => {
  const params = Object.fromEntries(searchParams);

  // Remove non filter params
  delete params.page;
  delete params.search;

  return params;
};

export const useFilters = (defaultFilter?: Record<string, string>) => {
  const [searchParams] = useSearchParams();
  const defaultFilterApplied = useRef(!defaultFilter && !searchParams.size);

  const [drawerOpen, setDrawerOpen] = useState(false);

  const closeDrawer = () => setDrawerOpen(false);
  const openDrawer = () => setDrawerOpen(true);

  const filterData = useMemo(() => {
    if (defaultFilter && !defaultFilterApplied.current && !searchParams.size) {
      defaultFilterApplied.current = true;

      return defaultFilter;
    }

    return getAppliedFilters(searchParams);
  }, [defaultFilter, searchParams]);

  return { filterData, drawerOpen, closeDrawer, openDrawer };
};
